/**
 * Resolve a storage URL for rendering in the browser.
 *
 * Backend code historically wrote `/storage/uploads/...` relative paths
 * to columns like `vendors.gallery`, expecting the same origin to serve
 * them. With the API on `dev-api.vowsera.com` and the frontend on
 * `dev.vowsera.com`, those relative paths 404 — the browser resolves
 * them against the page origin (frontend), but the storage symlink only
 * exists on the API host.
 *
 * This helper:
 *   - leaves absolute URLs alone (http://, https://, data:, blob:)
 *   - prepends the axios baseURL (the API host) for any path starting
 *     with `/storage/` or just `/`
 *   - returns the value unchanged if it's empty or unrecognised
 *
 * Use this anywhere a stored image URL is rendered (vendor gallery,
 * portfolio items, avatars, etc.).
 */
import api from '@services/api';

export const resolveStorageUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  if (url.startsWith('/')) {
    const base = api.defaults.baseURL || '';
    return `${base.replace(/\/+$/, '')}${url}`;
  }
  return url;
};

export default resolveStorageUrl;
